import React, { lazy, Suspense } from 'react';

const LazyProjectWizard = lazy(() => import('./ProjectWizard'));

const ProjectWizard = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyProjectWizard {...props} />
  </Suspense>
);

export default ProjectWizard;
